export enum UnitType {
    Text,
    Input
}